<!-- 按成员选择  有顾客的的员工-->
<template>
    <div class="onJobEmployeesList-list">
        <form action="/">
            <van-search class="search-button" v-model="searchStr" @search="onSearch" @clear="selClear" placeholder="搜索"
                left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
            </van-search>
        </form>
        <div v-if="storeInfoList.length>0" class="child-list-box">
            <div class="child-list-div" v-for="(item, index) in storeInfoList" @click="toChoice(item)" :key="index+item.id">
                <div class="child-contact-list flex-row">
                    <div class="child-img-div flex-col">
                        <img class="child-img" referrerpolicy="no-referrer" :src="item.avatar" alt="" />
                    </div>
                    <div class="child-contact-txt-div flex-col justify-between">
                        <span class="child-contact-txt">{{item.name}}</span>
                    </div>
                </div>
                <div class="child-section flex-col"></div>
            </div>
        </div>
        <div v-else class="flex flex-col flex-y-center">
            <img src="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-14/null.png" alt=""
                class="empty-icon" />
            <div class="empty-txt">暂无顾客～</div>
        </div>
    </div>

</template>
<script>
import request from "@/utils/request";
import { mapState } from 'vuex';

export default {

    name: "onJobEmployeesList",
    data() {
        return {
            searchStr: "",
            storeInfoList: {},
            type: 1,   //跳转页面
        };
    },

    mounted() {
        this.getEmployess();
        this.type = this.$route.query.toType;
    },
    // computed: {
    //     ...mapState({
    //         selectedEmp: (state) => state.inherit.selectedEmp, 
    //     }),
    // },
    methods: {

        //选择顾客
        toChoice(val) {
            if (this.type == 1) { //跳转在职继承页面
                this.updateBeReplacedEmplyees(val)
                this.$router.push({ name: "appointmentInherit", query: { checkedEmployeesInfo: JSON.stringify(val) } });
            }
            else {  //跳转选择客户页面
                this.updateSelectedEmp(val);
                this.$router.push({ name: "designatedCustomer", query: { checkedEmployeesInfo: JSON.stringify(val) } });
            }
        },
        // 选择成员
        updateSelectedEmp(emp) {
            this.$store.commit('inherit/SET_SELECTED_EMPId', emp)
        },
        // 接替成员
        updateBeReplacedEmplyees(emp) {
            this.$store.commit('inherit/SET_BEREPLACED_EMPId', emp)
        },
        getEmployess() {
            request({
                url: `/workEmployee/getEmpByStoreId`,
                method: "get",
                params: { mobile: this.searchStr }
            })
                .then((res) => {
                    this.storeInfoList = res.data;

                }).catch(() => {
                }).finally(() => {

                })
        },

        selClear() {
            this.searchStr = "";
        },

        //搜索
        onSearch() {
            this.page = 1;
            this.storeInfoList = [];
            this.getEmployess();
        }

    },
};
</script>

<style scoped>
.onJobEmployeesList-list {
    background-color: #ffffff;
}

.child-list-box {
    height: 82vh;
    justify-content: space-between;
    margin: 0 auto 0;
    position: relative;
    z-index: 1;
    overflow-y: auto;
}

.child-allchecked {
    margin-top: 20px;
    margin-left: 30px;
}

.child-list-div {
    margin-left: 30px;
    padding-bottom: 1px;
}

.child-contact-list {
    background-color: rgb(255 255 255);
    height: 130px;
}

.child-check-box {
    /* height: 35px; */
    margin-top: 60px;
    margin-left: 3px;
}

.child-img-div {
    position: relative;
    width: 70px;
    height: 70px;
    border-radius: 10px;
    overflow: hidden;
    margin-left: 30px;
    margin-top: 30px;
}

.child-img {
    z-index: 2;
    position: absolute;
    left: 0;
    top: 0;
    width: 70px;
    height: 70px;
}

.child-contact-txt-div {
    width: 90px;
    height: 92px;
    margin-left: 30px;
    margin-top: 52px;
}

.child-contact-txt {
    width: 90px;
    height: 42px;
    display: inline-block;
    color: rgba(53, 67, 76, 1);
    font-size: 30px;
    white-space: nowrap;
    line-height: 42px;
    text-align: left;
}

.child-contact-label {
    width: 32px;
    height: 32px;
    margin: 55px 0 0 384px;
}

.child-section {
    width: 520px;
    height: 1px;
    background-color: rgba(215, 215, 215, 1);
    margin: 0 0 0 130px;
}
.empty-icon {
    width: 280px;
    height: 280px;
    margin-top: 179px;
}

.empty-txt {
    font-size: 30px;
    color: #a0acb5;
}

:deep(.search-button.van-search) {
    padding: 30px 30px 30px 30px;
}
:deep(.search-button .van-icon) {
    font-size: 28px;
}
:deep(.search-button .van-search__content) {
    padding-left: 20px !important;
}
:deep(.search-button .van-field__left-icon) {
    color: #c8c9cc !important;
    padding: 3px 20px 0 0 !important;
    margin-right: 0 !important;
}

:deep(.van-icon__image) {
    height: 28px;
    display: inline-block;
}
:deep(.van-field__control) {
    font-size: 28px !important;
}
</style>
